import fetch from './api'
import global_ from "../global/index"

let serverurl = "";
if (process.env.NODE_ENV=='development') {
    serverurl = global_.global.tiku_local;
} else if (process.env.NODE_ENV=='testing') {
    serverurl = global_.global.tiku_test_url;
} else {
  serverurl = global_.global.tiku_online_url;
}
let paper_local_url = global_.global.paper_local_url;

//试卷批改教师点评详情信息
const GETPAPERCORRECTRESULT = params => {
    return fetch({
        url: '/api/admin/papercorrects/getPaperCorrectResult',
        method: 'get',
        params
    })
}

// 试卷批改-获取材料
const GETMATERIALINFO = params => {
    return fetch({
        url: '/api/admin/papercorrects/getQuestionMaterialInfo',
        method: 'get',
        params
    })
}


//试卷批改-教师点评
const ADDPAPERCORRECTQUESTIONRESULT = params => {
    return fetch({
        url: '/api/admin/papercorrects/addPaperCorrectQuetionResult',
        method: 'post',
        data: params
    })
}

//试卷批改-发布给学员
const PUBLISHCORRECTRESULT = params => {
    return fetch({
        url: '/api/admin/papercorrects/pubLishCorrectResult',
        method: 'get',
        params
    })
}

// 试卷批改-试卷详情
const GETUSERANSWERINFO = params => {
    return fetch({
        url: '/api/admin/papercorrects/getUserAnswerInfo',
        method: 'get',
        params: params
    })
}

// 试卷批改-获取列表
const GETPAPERCORRECTLIST = params => {
    return fetch({
        url: '/api/admin/papercorrects/getCorrectList',
        method: 'get',
        params: params
    })
}

// 判断试卷状态
const GETPAPERSTATUS = params => {
    return fetch({
        url: '/api/admin/papercorrects/getCurrectTimePaperStatus',
        method: 'get',
        params: params
    })
}

// 作业批改-获取列表
const GETEXERCISELIST = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseList',
        method: 'get',
        params: params
    })
}

// 作业批改-作业详情
const GETEXERCISEQUESTIONINFO = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseQuestionInfo',
        method: 'get',
        params: params
    })
}

// 作业批改-保存点评
const SAVECOMMENT = params => {
    return fetch({
        url: '/api/admin/exercise/saveComment',
        method: 'post',
        data: params
    })
}

// 作业批改-获取点评
const GETEXERCISECORRECTRET = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseCorrectRet',
        method: 'get',
        params: params
    })
}

// 作业批改-获取层级
const GETEXERCISEPAPERREPORT = params => {
    return fetch({
        url: '/api/admin/exercise/getExercisePaperReport',
        method: 'get',
        params: params
    })
}

// 作业批改-模考层级
const GETEXERCISEMOCKREPORT = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseMockReport',
        method: 'get',
        params: params
    })
}

// 保存画布批改
const SAVECORRECTINFO = params => {
  return fetch({
      url: '/api/admin/exercise/saveCorrectInfo',
      method: 'post',
      params: params
  })
}

// 获取单个画布信息
const GETCANVASINFO = params => {
  return fetch({
      url: '/api/admin/exercise/getCorrectInfo',
      method: 'get',
      params: params
  })
}

// 作业批改-驳回作答
const SAVEREJECTUSERANSWER = params => {
    return fetch({
        url: '/api/admin/exercise/saveRejectUserAnswer',
        method: 'post',
        data: params
    })
}

// 作业批改-获取驳回信息
const GETREJECTUSERANSWER = params => {
    return fetch({
        url: '/api/admin/exercise/getRejectUserAnswer',
        method: 'get',
        params: params
    })
}

// 作业批改-获取层级
const GETEXERCISEPRACTICEREPORT = params => {
    return fetch({
        url: '/api/admin/exercise/getExercisePracticeReport',
        method: 'get',
        params: params
    })
}

// 作业批改-发布批改
const PUBEXERCISECORRECT = params => {
    return fetch({
        url: '/api/admin/exercise/pubExerciseCorrect',
        method: 'post',
        data: params
    })
}

// 作业批改-生成答题卡
const PRODUCEANSWERSHEET = params => {
    return fetch({
        url: '/api/admin/exercise/produceAnswerSheet',
        method: 'get',
        params: params
    })
}

// 作业批改-获取学员问答
const GETUSERMSG = params => {
    return fetch({
        url: '/api/admin/exercise/getUserMsg',
        method: 'get',
        params: params
    })
}

// 作业批改-回复学员问答
const REPLYMSG = params => {
    return fetch({
        url: '/api/admin/exercise/replyMsg',
        method: 'post',
        data: params
    })
}
// 作业批改-暂不回复
const PAUSEREPLYMSG = params => {
    return fetch({
        url: '/api/admin/exercise/pauseReplyMsg',
        method: 'get',
        params: params
    })
}
// 作业批改-教务跳转到批改-试卷练习册
const GETEXERCISERECORDINFO = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseRecordInfo',
        method: 'get',
        params: params
    })
}
// 作业批改-教务跳转到批改-模考
const GETEXERCISERECORDINFOFORMOCK = params => {
    return fetch({
        url: '/api/admin/exercise/getExerciseRecordInfoForMock',
        method: 'get',
        params: params
    })
}
// ---------------------------------2020.03.24------------------------------------
// 付费批改--获取试卷批改结果
const GETCORRECTINFO = params => {
    return fetch({
        url: serverurl + '/apiv3/api/api/getCorrectReportInfo',
        method: 'post',
        data: params
    })
}
// 付费批改--获取试卷材料
const GETCORRECTDATA= params => {
    return fetch({
        url: serverurl + '/apiv3/api/api/getMaterialOfPaper',
        method: 'post',
        data: params
    })
}

export default {
    PUBLISHCORRECTRESULT,
    ADDPAPERCORRECTQUESTIONRESULT,
    GETMATERIALINFO,
    GETPAPERCORRECTRESULT,
    GETPAPERCORRECTLIST,
    GETPAPERSTATUS,
    GETCORRECTINFO,
    GETCORRECTDATA,
    GETUSERANSWERINFO,
    GETEXERCISELIST,
    GETEXERCISEQUESTIONINFO,
    SAVECOMMENT,
    GETEXERCISECORRECTRET,
    GETEXERCISEPAPERREPORT,
    GETEXERCISEMOCKREPORT,
    SAVEREJECTUSERANSWER,
    GETREJECTUSERANSWER,
    GETEXERCISEPRACTICEREPORT,
    PUBEXERCISECORRECT,
    PRODUCEANSWERSHEET,
    GETUSERMSG,
    REPLYMSG,
    PAUSEREPLYMSG,
    GETEXERCISERECORDINFO,
    GETEXERCISERECORDINFOFORMOCK,
    SAVECORRECTINFO,
    GETCANVASINFO
}



// WEBPACK FOOTER //
// ./src/api/interface-papercorrection.js